import { APIBASE } from '../../../constants/api.constants'
import { APIROUTES, fillPath } from '../../../constants/routes.constants'

/**
 * Shared storefront media helpers — used by the gallery and the lightbox so
 * the URL builder, the image/video discriminator, and the play badge live in
 * ONE place (Rule #21 / single-source).
 */

export function mediaUrl(mediaId: string): string {
  return `${APIBASE}${fillPath(APIROUTES.SHOPMEDIA, { id: mediaId })}`
}

export function isVideo(contentType: string): boolean {
  return contentType.startsWith('video/')
}

/** White play triangle overlaid on a video thumbnail. */
export function PlayBadge(): JSX.Element {
  return (
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-bg-primary/85 shadow-sm">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="text-charcoal" aria-hidden>
        <path d="M8 5v14l11-7z" />
      </svg>
    </span>
  )
}
